export default {"src":"/_next/static/media/stressMotivation.c952ae5c.svg","height":645,"width":1048,"blurWidth":0,"blurHeight":0};